import { render, staticRenderFns } from "./BusinessTodoView.vue?vue&type=template&id=0ad5bfc5"
import script from "./BusinessTodoView.vue?vue&type=script&lang=js"
export * from "./BusinessTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports